import { formatDateBR } from "@/lib/date-utils";
import type { FutureRow } from "@/hooks/useFutureRows";

export interface UpcomingStayDayRow {
  reservationId: string;
  petId: string;
  petName: string | null;
  stayDate: string;
  moduleType: string;
  recurrenceSummary: string | null;
}

/**
 * Uma linha por reserva, ancorada na próxima ocorrência. A cadência inteira
 * vira o detalhe — expandir cada dia da recorrência inundaria a aba.
 */
export function buildStayFutureRows(days: UpcomingStayDayRow[], t: (key: string) => string): FutureRow[] {
  const byReservation = new Map<string, UpcomingStayDayRow>();
  for (const day of days) {
    const current = byReservation.get(day.reservationId);
    if (!current || day.stayDate < current.stayDate) byReservation.set(day.reservationId, day);
  }

  return [...byReservation.values()]
    .sort((left, right) => left.stayDate.localeCompare(right.stayDate))
    .map((day) => ({
      key: `stay-${day.reservationId}`,
      category: "estadia" as const,
      typeLabel: day.moduleType === "hotel" ? t("futureTab.stay.hotel") : t("futureTab.stay.daycare"),
      detailLabel: day.recurrenceSummary,
      timestamp: new Date(`${day.stayDate}T12:00:00.000Z`).getTime(),
      dateLabel: formatDateBR(day.stayDate),
      statusLabel: t("futureTab.stay.scheduled"),
      statusKey: "scheduled",
      isScheduled: true,
      estimatedAmount: null,
      resolutionStatus: "scheduled" as const,
      petId: day.petId,
      petName: day.petName,
      editablePlan: null,
      editableVaccination: null,
    })) as FutureRow[];
}
